import "../Styles/MakeUp.css";
import hearts from "../../../public/wardrobe/hearts.jpg";
import Container from "./Container";
import SubmitButton from "./SubmitButton";
import Lipgloss from "../../../public/graphics/huulikiilto.png";
import LipLines from "../../../public/graphics/huultenrajaus.png";
import Dialogue from "../Dialogue";
import { useEffect, useRef, useState } from "react";
import ImgRadioButton from "./ImgRadioButton";
import "../Styles/InfoScreen.css";
import { Authors } from "./EndScreen";

const InfoScreen = (props) => {
  return (
    <>
      {props.visible && (
        <>
          <Container class={"info-view-container"} headerText={"Info"}>
            <div class="info-text">
              <p
                style={{
                  fontSize: "large",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: "1.4px",
                  marginTop: "2em",
		  marginBottom: "2em"
                }}
              >
                Siis MIKÄ juttu tää on?
              </p>

              <p>
            
		Tehtäväsi on päästä parhaan ystäväsi syntymäpäiväbileisiin. Voit
                tutkia huonetta ja täpätä esineitä.
              </p>

              <p>
                Löydätkö ystävällesi lahjan? Hyvän asun ja meikit? Ja sitten on
                vielä se Jakekin...{" "}
              </p>
              <p>
                Peli on osa IT-kupla.net -audiosarjan verkkokokonaisuutta.
                Sukella syvemmälle vuosituhannen alun Suomeen Areenassa.
              </p>

	      <SubmitButton
                submitClicked={() => props.close()}
                text={"Takaisin peliin"}
		style= {{
			margin: "25px 8px"
		}}
              />
	      
	      <SubmitButton
                submitClicked={() => window.location.href="https://areena.yle.fi/podcastit/1-66020022"}
                text={"Avaa Yle Areena"}
		style= {{
			margin: "25px 8px"
		}}
              />
              <img
                id="it-kupla-kuva"
                src="https://images.cdn.yle.fi/image/upload/ar_1:1,c_fill,d_yle-areena.jpg,f_auto,fl_lossy,q_auto:eco,w_640/v1687757056/13-1-66020022-1685701619597.jpg"
              />
              <Authors />
            </div>
          </Container>
        </>
      )}
    </>
  );
};

export default InfoScreen;
